import React from 'react';

const fmt1 = (x) => (Number.isFinite(Number(x)) ? Number(x).toFixed(1) : "");
const fmt0 = (x) => (Number.isFinite(Number(x)) ? Number(x).toFixed(0) : "");
const fmtSigned0 = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  const s = n > 0 ? "+" : "";      // keep '-' automatically
  return s + n.toFixed(1);
};
const fmtAbs1 = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.abs(n).toFixed(1) : "";
};

// ---------------------------
  // Flight Planning row 
  // uses ? the ternary operator to avoid displaying NaN for empty fields
  // uses ?? the coalescing operator to handle null/undefined values
  // ---------------------------
function WcaRow({plan, index, onEdit}) {
    const windText =
            Number.isFinite(Number(plan.windDir)) || Number.isFinite(Number(plan.windSpd))
            ? `${fmt0(plan.windDir)}° / ${fmt1(plan.windSpd)} kts.`
            : "";

      const cellInput = (field, className="navlog-input") => (
        <input
          className={className}
          value={plan[field] ?? ""}
          onChange={(e) => onEdit(index, field, e.target.value)}
        />
      );


  return (
    <tr>
       <td className="navlog-ft-col">
        <div className="navlog-ft-display">{plan.ft}</div>
        
      </td>
      

      <td className="navlog-cruisealt-col">{cellInput("cruiseAlt")}</td>
      <td className="navlog-cas-col">{cellInput("cas")}</td>
      <td className="navlog-tc-col">{cellInput("tc")}</td>
      <td className="navlog-tas-col navlog-output">{fmt1(plan.tas)}</td>
      <td className="navlog-wind-col navlog-output">{windText}</td>
      <td className="navlog-wca-col navlog-output">{fmt1(plan.wca)}°</td>
      <td className="navlog-th-col navlog-output">{fmt1(plan.th)}°</td>
      
      <td className="navlog-hw-col navlog-output">
          <div className="hw-cell">
            {Number.isFinite(Number(plan.hw)) && (
              <>
                <span
                  className={
                    Number(plan.hw) > 0
                      ? "hw-arrow hw-headwind"
                      : "hw-arrow hw-tailwind"
                  }
                >
                  {Number(plan.hw) > 0 ? "↓" : "↑"}
                </span>
                <span className="hw-value">{fmtAbs1(plan.hw)}</span>
              </>
            )}
          </div>
        </td>

        <td className="navlog-cw-col navlog-output">
          <div className="cw-cell">
          {Number.isFinite(Number(plan.cw)) && (
            Number(plan.cw) < 0 ? (
              <>
                <span className="cw-arrow cw-left">→</span>
                <span className="cw-value">{fmtAbs1(plan.cw)}</span>
              </>
            ) : Number(plan.cw) > 0 ? (
              <>
                <span className="cw-value">{fmtAbs1(plan.cw)}</span>
                <span className="cw-arrow cw-right">←</span>
              </>
            ) : (
              <span className="cw-value">{fmtAbs1(plan.cw)}</span>
            )
          )}
          </div>
        </td>
    </tr>
  );
}

export default WcaRow;
